// removed by extract-text-webpack-plugin
module.exports = {"addButton":"add-button--2sRSB","selectBox":"select-box--3NSAi","deleteIcon":"delete-icon--1Qzhg"};


//////////////////
// WEBPACK FOOTER
// ./app/components/commons/formElements/selectWithAdd/selectWithAdd.scss
// module id = iFxk
// module chunks = 1